/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TimeTrialCto } from '../../models/time-trial-cto';

export interface GetCompanyTimeTrial$Json$Params {
  companyId: string;
}

export function getCompanyTimeTrial$Json(http: HttpClient, rootUrl: string, params: GetCompanyTimeTrial$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TimeTrialCto>>> {
  const rb = new RequestBuilder(rootUrl, getCompanyTimeTrial$Json.PATH, 'get');
  if (params) {
    rb.path('companyId', params.companyId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<TimeTrialCto>>;
    })
  );
}

getCompanyTimeTrial$Json.PATH = '/company/{companyId}/timetrial';
